<template>
  <v-card class="">
    <v-card
      class="px-3 py-2 mb-3"
      flat
      tile
      color="blue lighten-2"
    >
      {{ $t('m.estiResult') }}
    </v-card>
    <v-card
      class="px-3 pb-2"
      flat
      tile
    >
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            outlined
            hide-details
            type="number"
            disabled
            :value="getHirePerDay"
            background-color="#E3F2FD"
            :label="$t('m.asHirePerDay')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            outlined
            hide-details
            type="number"
            disabled
            :value="getTtlRevenue"
            background-color="#E3F2FD"
            :label="$t('m.ttlRevenue')"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            outlined
            hide-details
            type="number"
            disabled
            :value="getOpExpense"
            background-color="#E3F2FD"
            :label="$t('m.opCost')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            outlined
            hide-details
            type="number"
            disabled
            :value="getOpProfit"
            background-color="#E3F2FD"
            :label="$t('m.opProfit')"
          />
        </v-col>
      </v-row>
      <v-row
        dense
        class=""
      >
        <v-col cols="6">
          <v-text-field
            dense
            outlined
            hide-details
            type="number"
            disabled
            :value="getTtlExpense"
            background-color="#E3F2FD"
            :label="$t('m.ttlExpense')"
          />
        </v-col>
        <v-col cols="6">
          <v-text-field
            dense
            outlined
            disabled
            hide-details
            type="number"
            :value="getProfit"
            background-color="#E3F2FD"
            :label="$t('m.netProfit')"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'

export default {
  name: 'ResultPad',
  components: { },
  props: [
    'model'
  ],
  data () {
    return {

    }
  },
  created () {
    if (this.model) {
      this.resetForm()
    }
  },
  computed: {
    ...mapState({
      editFlag: state => state.estimating.editFlag,
      resetMessage: state => state.estimating.resetMessage,
      clearFlag: state => state.estimating.clearFlag
    }),

    ...mapGetters({
      ttlAddComm: 'getAddCommRateVal',
      ttlBrokerage: 'getBrokerageRateVal',
      ttlFrtTax: 'getFrtTax',
      ttlPortCharge: 'getPortCharge',
      fuelCost: 'getFuelCost',
      getRent: 'getRent',
      getRentAndCom: 'getRentAndCom',
      getOpExpense: 'getOpExpense',

      getHirePerDay: 'getHirePerDay',
      getOpProfit: 'getOpProfit',
      getProfit: 'getProfit',
      getTtlRevenue: 'getTtlRevenue',
      getTtlExpense: 'getTtlExpense'
    })

  },
  watch: {

  },
  methods: {
    resetForm () {

    },

    clearForm () {
    }
  }

}
</script>

<style scoped>

</style>
